import { useState, useEffect } from 'react';
import { OrganizationMembershipResponse } from '@/shared/api';
import { StorageKeys } from '@/shared/types';
import { apiCookies } from '@/shared/utils';

export const useActiveOrganization = () => {
  const [activeOrganization, setActiveOrganization] = useState<
    Partial<OrganizationMembershipResponse> | undefined
  >({
    id: apiCookies.get(StorageKeys.ActiveOrganization),
  });

  useEffect(() => {
    if (activeOrganization?.id) {
      apiCookies.set(StorageKeys.ActiveOrganization, activeOrganization.id);
    } else {
      apiCookies.remove(StorageKeys.ActiveOrganization);
    }
  }, [activeOrganization]);

  return [activeOrganization, setActiveOrganization] as const;
};
